import type { MembershipTier } from '@/types/live-session';

export function mapMembershipToTier(value: string): MembershipTier {
  if (value === 'pro') return 'pro';
  if (value === 'regular' || value === 'standard') return 'regular';
  return 'non_member';
}

export function isMemberTier(tier: MembershipTier): boolean {
  return tier === 'pro' || tier === 'regular';
}
